import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationFR from "./fr.json";
import translationEN from "./en.json";
import LanguageDetector from "i18next-browser-languagedetector";
import axiosConfig from "../services/Axios";

const resources = {
  fr: {
    translation: translationFR,
  },
  en: {
    translation: translationEN,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false,
    },
  });

axiosConfig.defaults.headers["Accept-Language"] = i18n.language;

export default i18n;
